import React from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { Form, Field } from "react-final-form";
import { WhenFieldChangesDo } from '../../libraries/forms';
import { ToastContainer, notify } from "../../libraries/notifications";

import { history } from '../../routes';
import config from "../../config";

import favorsActions from "../../context/favors/actions";

import BottomNav from '../../components/commons/BottomNav';
import Loader from '../../components/commons/Loader';
import Icon from "../../libraries/icons";
import LayoutSmall from "../../components/layout/LayoutSmall";
import FavorElement from "../../components/customs/FavorElement";
import SearchInput from "../../components/forms/SearchInput";
import SelectInput from "../../components/forms/SelectInput";
import { capitalize, toBool } from '../../libraries/utils';

class Favors extends React.Component {
  constructor(props) {
    super(props);
    this.t = this.props.t;
    this.state = {
      favors: [],
      search: "",
      unique_id: this.props.auth.user.unique_id,
      viewAll: true,
    };
  }

  componentDidMount() {
    if (this.props.auth.user?.ancestors) {
      let companiesIds = this.props.auth.user.ancestors.companies.map(c => c.id)
      this.setState({ companiesIds, unique_id: companiesIds, viewAll: true }, this.getFavors)
    }
  }

  getFavors = async () => {
    const { search, filters } = this.state
    const params = { status: config.STATUS.FAVORS.AVAILABLE, unique_id: this.state.unique_id }

    if (search && search !== "") {
      params.name = `%${search.toLowerCase()}`
    }

    await this.props.onGetAllFavors(params);
    const { favors } = this.props;
    if (favors.error) {
      notify(this.t(favors.error.message));
    } else {
      this.setState({ favors: favors.items });
    }
  };

  searchClear = (form) => {
    form.change('search', undefined);
    this.searchOnClick({ search: '' });
  }

  searchOnClick = async (values) => {
    console.log("Search on Click", values.search);
    if (this.state.search !== values.search) this.setState({ search: values.search || '' }, () => this.getFavors());
  };

  goBack = () => {
    history.push({ pathname: config.ROUTES.HOME, state: { from: config.ROUTES.MAIN.OFFER } });
  }

  setViewAll = (viewAll) => {
    let unique_id = this.props.auth.user.unique_id
    this.setState({ viewAll, unique_id: viewAll ? this.state.companiesIds : unique_id }, this.getFavors)
  }

  onSubmit = (value) => {
    this.setViewAll(toBool(value));
  }


  render() {
    const { favors } = this.state;
    const options = [{ value: true, label: capitalize(this.t('all the accounts')) }, { value: false, label: capitalize(this.t('my office')) }];

    return (
      <LayoutSmall
        main={{ className: "pb-14" }}
        header={{
          title: this.t("Favors"),
          className: "bg-primary",
          left: { icon: 'arrow_left', action: () => this.goBack() },
        }}
        container={{ className: "px-0" }}
      >
        <ToastContainer />
        {/* <SelectInput className="" selectClassName="bg-transparent p-1" input={{ name: 'select', onChange: this.changeOrigin }} options={options} noError={true} /> */}
        <section className="min-h-full py-6 bg-base-200 max-w-lg mx-auto">
          <div className="px-4">
            <Form initialValues={{}} onSubmit={this.searchOnClick}>
              {({ handleSubmit, form, submitting, pristine, values }) => (
                <form onSubmit={handleSubmit} className="w-full max-w-lg mx-auto mb-4">
                  <Field name="search" component={SearchInput} placeholder={this.t("Search")} onClick={this.searchOnClick} onClearClick={() => this.searchClear(form)} />
                  <Field name="viewAll" component={SelectInput} className="pt-2" selectClassName="select-ghost select-sm w-40" options={options} noError={true} />
                  <WhenFieldChangesDo field="viewAll" action={({ field, value, values }) => { this.onSubmit(value); }} />
                </form>
              )}
            </Form>
          </div>
          <div>
            {this.props.favors.loading && (<Loader />)}
            {!this.props.favors.loading && favors.length === 0 && (
              <div className="text-center p-10">
                <Icon className="h-24 w-24 mx-auto mb-3" name="stethoscope" />
                <h4 className="mb-1">{this.t("No hay favores")}</h4>
              </div>
            )}
            <div className="container-fluid bg-white shadow">

              {favors && favors.map((favor, index) => {
                return (
                  <FavorElement
                    key={'p' + index}
                    route={{ pathname: config.ROUTES.FAVORS.DETAIL.replace(':id', favor.id), state: { from: config.ROUTES.FAVORS.LIST } }}
                    favor={favor}
                  />
                )
              })
              }
            </div>
          </div>
        </section>
        <BottomNav />
      </LayoutSmall>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.users.auth,
    favors: state.favors.list,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onGetAllFavors: (params) => dispatch(favorsActions.getAll(params)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(Favors));
